<ng-container *transloco="let t">
  @if (sentimentCenters?.length > 0) {
    <h3>{{ t('documents.sentiment.sentiment-polarity') }}</h3>
    @for (item of sentimentCenters; track item; let i = $index) {
      <div class="sentiment-radio">
        <xi-radio
          [value]="item.sentimentPolarity"
          [label]="item.sentimentPolarity | titlecase"
          [(ngModel)]="manualSentiment.value"
          name="sentimentPolarity"
          (onChange)="adjustSentimentSlider($event.detail.target.value)"
        >
        </xi-radio>
        <app-sentiment-display
          sentimentDisplay="polarity"
          [sentimentScale]="sentimentScale()"
          [sentimentRanges]="sentimentCenters"
          [item]="itemsForSentimentDisplay[i]"
          [showTooltip]="false"
        ></app-sentiment-display>
      </div>
    }
    <h3>{{ t('documents.sentiment.sentiment-score') }}</h3>
    <xi-slider
      [min]="sentimentCenters[0].min"
      [max]="sentimentCenters[sentimentCenters.length - 1].max"
      [increment]="1e-1"
      [inflection]="{
        inflectionPoint: 0,
        sentimentLeft: 'negative',
        sentimentRight: 'positive',
      }"
      [value]="manualSentiment.score"
      (onSliderChange)="adjustSentimentRadio($event.detail.value)"
    ></xi-slider>
  }
</ng-container>
